<template>
  <PrimaryButton
    aria-label="Request Missing Frameworks"
    @click="requestFramework"
  >
    Request Missing Frameworks
  </PrimaryButton>
</template>

<script>
export default {
  name: 'RequestEsgFrameworksButton',

  methods: {
    requestFramework() {
      window.open(
        'https://zunocarbon.atlassian.net/servicedesk/customer/portals',
        '_blank',
      )
    },
  },
}
</script>
